// extracted by mini-css-extract-plugin
export default {"root":"recipes-new_root__zVRH9","pageRoot":"recipes-new_pageRoot___vXE4"};